// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"23c75050","453":"c2ef2e95","948":"1e745a73"}[chunkId] + ".chunk.js";
};